<template lang="pug">
    div( v-show="showColorPicker || showPicker" class="color-picker-container")
        div(v-show="insider === null" v-for="color in backgroundColors" @click="changeColor(color)" class="color-item" :class="(changedColor === null) ? (selectedColor === color) ? 'item-border' : '' : (changedColor === color) ? 'item-border' : ''" :style="`background:${color};`")
        div(v-show="insider !== null" v-for="color in backgroundColors" @click="changeColorLocal(color)" class="color-item" :class="(changedColor === null) ? (selectedColor === color) ? 'item-border' : '' : (changedColor === color) ? 'item-border' : ''" :style="`background:${color};`")
</template>

<script>
import ApiService from '@/Services/ApiService.js';
import Vue from 'vue';
import _ from 'lodash';
import { mapMutations } from 'vuex';

export default Vue.extend({
    name: 'ColorPicker',
    props: {
        selectedColor: String,
        showPicker: {
            type: Boolean,
            default: false
        },
        insider: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            showColorPicker: false,
            clickedNote: null,
            changedColor: null,
            backgroundColors: ['#C2E0FC', '#C9FDCE', '#FFFFBA', '#FAE0BF', '#F4B6BB']
        };
    },
    computed: {
        user_id() {
            return JSON.parse(localStorage.getItem('user')).user_id;
        }
    },
    methods: {
        ...mapMutations([
            'setRegisterType',
            'setRegisterWindows'
        ]),
        setClickedNote(item) {
            this.clickedNote = item;
        },
        closeColorPicker() {
            this.showColorPicker = false;
            this.changedColor = null;
        },
        openColorPicker() {
            this.showColorPicker = true;
        },
        async changeColorLocal(color) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            this.changedColor = color;

            const diary_item_id = this.insider.diary_item_id;
            const background = color;

            const colorUpdateObject = {
                diary_item_id,
                background
            };

            await ApiService.updateDiaryItem(colorUpdateObject);

            this.$store.commit('updateMapUserDiaryItem', Object.assign({}, colorUpdateObject, { key: 'background' }));

            this.$emit('updateChart');
        },
        async changeColor(color) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            this.changedColor = color;

            const diary_item_id = this.clickedNote.diary_item_id;
            const background = color;

            const colorUpdateObject = {
                diary_item_id,
                background
            };

            await ApiService.updateDiaryItem(colorUpdateObject);

            this.$store.commit('updateMapUserDiaryItem', Object.assign({}, colorUpdateObject, { key: 'background' }));

            this.$emit('updateChart');

            if(document.getElementById(this.clickedNote.stock_id) !== null) {
                let tempNotes = this.$store.getters["getMapUserDiary"].filter(item => item.stock_id === this.clickedNote.stock_id);
                const sortedTempNotes = _.orderBy(tempNotes, ['date_created', 'diary_item_id'], ['desc', 'desc']);
                const diaryElement = document.getElementById(this.clickedNote.stock_id);

                diaryElement.style.backgroundColor = (sortedTempNotes[0].background).trim();
            }
        }
    }
})
</script>

<style scoped>

.color-picker-container {
    position: fixed;
    padding-left: 4px;
    padding-top: 4px;
    padding-bottom: 4px;
    border-radius: 4px;
    z-index: 1000;
}

.color-item {
    cursor: pointer;
    float: left;
    width: 16px;
    height: 16px;
    margin-right: 4px;
    border-radius: 50px;
    box-shadow: 0 0 4px rgba(100,100,100,.4);

}

.color-item:hover {
    box-shadow: none;
}

.item-border {
    border: 1px solid rgba(255,255,255,1);
    box-shadow: 0 0 4px rgba(100,100,100,.4) !important;
}
</style>
